import { createApp } from 'vue/dist/vue.esm-bundler.js';
import SearchIndex from '../components/SearchIndex.vue';
document.addEventListener('afterBlitzInjectAll', () => {
    // Mount Vue app if target exists
    const target = document.querySelector('#search-results');
    if (target) {
        createApp(SearchIndex).mount(target);
    } else {
        console.warn('⚠️ #search-results element not found — Vue app not mounted.');
    }
});
